// Converts a date-string (YYYY-MM-DD Format) into a Date object
const convertStringToDate = (dateStr: string) => {
	const [year, month, day] = dateStr.split('-');
	return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
};

// Formats a Date object to MM/DD
const formatDateToMMDD = (dateObj: Date) => {
	const month = String(dateObj.getMonth() + 1).padStart(2, '0');
	const date = String(dateObj.getDate()).padStart(2, '0');
	return `${month}/${date}`;
};

export { convertStringToDate, formatDateToMMDD };
